export default function formatDate(date?: string | null) {
  if (!date) {
    return "";
  }

  // Mantém valores não-data como "Atualmente"
  const match = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return date;
  }

  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}
